module.exports = __webpack_public_path__ + "img/news31-1.03108179.png";